import { actions, selectors } from '@sloyd/store-base';
import { fork, put, select, takeEvery } from 'saga-ts';
import { invokeEvent, l, setBackgroundMusicPosition } from 'shared-base';
import { customEventChannel } from './channels/channel.customEvent';
import { playKeyframeAudio } from './helpers/saga.audio';
import { playKeyframeCamera, stopAll } from './helpers/saga.camera';
import { playKeyframeHud } from './helpers/saga.hud';
import { playKeyframeSfx } from './helpers/saga.sfx';

export function* musicTime(ev: any): Generator<any, void, any> {
  const { data } = ev;
  const { ts } = data;

  const keyframes = yield select(selectors.base.$currentKeyframes, ts);

  for (let k of keyframes) {
    invokeEvent('KEYFRAME_DANCE', k.id);

    switch (k.type) {
      case 'camera':
        yield fork(playKeyframeCamera, k);
        break;
      case 'audio':
        yield fork(playKeyframeAudio, k);
        break;
      case 'hud':
        yield fork(playKeyframeHud, k);
        break;
      case 'sfx':
        yield fork(playKeyframeSfx, k);
        break;
    }
  }
}

export function* musicSeek(ev: any): Generator<any, void, any> {
  const { data } = ev;
  const { ts } = data;
  setBackgroundMusicPosition(ts);
}

export function* musicStatus(ev: any): Generator<any, void, any> {
  const { data } = ev;
  const { status } = data;

  switch (status) {
    case 'PLAYING':
      yield put(actions.animationState.patch({ isRunning: true }));
      stopAll();
      break;
    case 'PAUSED':
      yield put(actions.animationState.patch({ isRunning: false }));
      yield put(actions.animationState.patch({ showHud: false }));
      stopAll();
      break;
    case 'STOPPED':
      yield put(actions.animationState.patch({ isRunning: false }));
      yield put(actions.animationState.patch({ showHud: false }));
      break;
  }
}

export function* root(): Generator<any, void, any> {
  l('saga|saga.three');

  let channel: any;

  channel = customEventChannel('MUSIC_TIME');
  yield takeEvery(channel, musicTime);

  channel = customEventChannel('MUSIC_SEEK');
  yield takeEvery(channel, musicSeek);

  channel = customEventChannel('MUSIC_STATUS');
  yield takeEvery(channel, musicStatus);
}

// Export saga
export const saga = {
  id: 'sloyd.three',
  type: 'bootstrap',
  root,
  trigger: {},
};
